import { Card, CardContent, Stack, Typography } from '@mui/material';
import React from 'react';
import { EmailNeonSales } from '../../ui/EmailNeonSales';

interface FurtherAssistanceEmailProps {
    className?: string;
}

export const FurtherAssistanceEmail = ({
    className,
}: FurtherAssistanceEmailProps): JSX.Element => {
    return (
        <Card variant="outlined" className={className}>
            <CardContent>
                <Stack spacing={2}>
                    <Typography variant="h6">
                        If you need further assistance
                    </Typography>
                    <Stack spacing={0.5}>
                        <Typography variant="body1">Email us at</Typography>
                        <EmailNeonSales />
                    </Stack>
                </Stack>
            </CardContent>
        </Card>
    );
};
